/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { capacity_AdaptAllocationsRequest } from '../models/capacity_AdaptAllocationsRequest';
import type { capacity_AdaptAllocationsResponse } from '../models/capacity_AdaptAllocationsResponse';
import type { capacity_CapacityAttentionResponse } from '../models/capacity_CapacityAttentionResponse';
import type { capacity_CategorizationListResponse } from '../models/capacity_CategorizationListResponse';
import type { capacity_ChildCategorizationResponse } from '../models/capacity_ChildCategorizationResponse';
import type { capacity_GroupUtilizationRangeResponse } from '../models/capacity_GroupUtilizationRangeResponse';
import type { capacity_GroupUtilizationResponse } from '../models/capacity_GroupUtilizationResponse';
import type { capacity_MoveAllocationsRequest } from '../models/capacity_MoveAllocationsRequest';
import type { capacity_MoveAllocationsResponse } from '../models/capacity_MoveAllocationsResponse';
import type { capacity_OrgCapacityOverviewResponse } from '../models/capacity_OrgCapacityOverviewResponse';
import type { capacity_OrgCapacityRangeResponse } from '../models/capacity_OrgCapacityRangeResponse';
import type { capacity_QuarterCalendarResponse } from '../models/capacity_QuarterCalendarResponse';
import type { capacity_RecentMovesResponse } from '../models/capacity_RecentMovesResponse';
import type { capacity_ServiceBreakdownResponse } from '../models/capacity_ServiceBreakdownResponse';
import type { capacity_WeekCalendarResponse } from '../models/capacity_WeekCalendarResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CapacityService {
    /**
     * Move children between groups in bulk
     * Projects (dry_run=true) or commits (dry_run=false) a bulk group move. A dry run returns the per-child before/after placement, the per-target-service-window projected occupancy with breach flags, and any hard blockers — and writes nothing. A commit ends each child's current allocation at effective_date - 1 and creates the new allocation(s) in the target group, all in one transaction. Over-capacity is warn-and-allow: only a true impossibility (the same child in two groups during the same service window) is blocked.
     * @param request Move request
     * @returns capacity_MoveAllocationsResponse OK
     * @throws ApiError
     */
    public static postApiV1CapacityAllocationsMove(
        request: capacity_MoveAllocationsRequest,
    ): CancelablePromise<capacity_MoveAllocationsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/capacity/allocations/move',
            body: request,
            errors: {
                400: `Invalid request body or validation failure`,
                401: `Authentication required or invalid credentials`,
                403: `Organization or user ID not found in token`,
                404: `Group or child not found`,
                409: `Allocation modified by another user`,
                422: `Move is hard-blocked by an unresolvable conflict`,
                500: `Failed to move allocations`,
            },
        });
    }
    /**
     * Get recent group changes (move history)
     * Returns recent child group changes reconstructed from the allocation audit trail. Read-only; no dedicated history table exists. Each item carries the from/to group and effective date needed to undo it via the move endpoint.
     * @param days Lookback window in whole org-local days (default 7, clamped to 90)
     * @param mine Restrict to moves made by the calling user
     * @param limit Page size (default 25, max 100)
     * @param offset Page offset (default 0)
     * @returns capacity_RecentMovesResponse OK
     * @throws ApiError
     */
    public static getApiV1CapacityAllocationsMovesRecent(
        days?: number,
        mine?: boolean,
        limit?: number,
        offset?: number,
    ): CancelablePromise<capacity_RecentMovesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/capacity/allocations/moves/recent',
            query: {
                'days': days,
                'mine': mine,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Invalid days, mine, limit or offset`,
                401: `Authentication required or invalid credentials`,
                403: `Organization ID not found in token`,
                500: `Failed to load move history`,
            },
        });
    }
    /**
     * Get capacity attention items
     * Returns severity-ranked, server-aggregated capacity attention items (aging_out, over_capacity, out_of_sync, unresolved_conflict) for a forward-looking horizon
     * @param location Childcare ID to scope the items to
     * @param horizonDays Forward horizon in days (default 60, clamped to 90)
     * @returns capacity_CapacityAttentionResponse OK
     * @throws ApiError
     */
    public static getApiV1CapacityAttention(
        location?: string,
        horizonDays?: number,
    ): CancelablePromise<capacity_CapacityAttentionResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/capacity/attention',
            query: {
                'location': location,
                'horizon_days': horizonDays,
            },
            errors: {
                400: `Invalid location ID or horizon_days`,
                401: `Authentication required or invalid credentials`,
                403: `Organization ID not found in token`,
                404: `Childcare not found`,
                500: `Failed to calculate capacity attention items`,
            },
        });
    }
    /**
     * Get quarterly calendar data
     * Returns 3 months of aggregated calendar data with metrics and trends
     * @param year Year (e.g., 2025)
     * @param quarter Quarter number (1-4)
     * @returns capacity_QuarterCalendarResponse OK
     * @throws ApiError
     */
    public static getApiV1CapacityCalendarQuarter(
        year: number,
        quarter: number,
    ): CancelablePromise<capacity_QuarterCalendarResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/capacity/calendar/quarter',
            query: {
                'year': year,
                'quarter': quarter,
            },
            errors: {
                400: `Invalid year or quarter parameter`,
                401: `Authentication required or invalid credentials`,
                403: `Organization ID not found in token`,
                500: `Failed to fetch quarter calendar data`,
            },
        });
    }
    /**
     * Get weekly calendar data
     * Returns calendar data for a specified date range with groups, allocations, and utilization. Supports locale-aware week starts (Sunday or Monday).
     * @param startDate Start date for the calendar window (YYYY-MM-DD format). If week_starts_on is provided, this will be adjusted to the start of that week. Defaults to today if omitted.
     * @param weekStartsOn Day that starts the week: 0=Sunday, 1=Monday, 2=Tuesday, 3=Wednesday, 4=Thursday, 5=Friday, 6=Saturday. Range: 0-6. Default: 0 (Sunday). Takes precedence over deprecated week_start parameter.
     * @param days Number of days to display. Range: 1-31. Default: 7.
     * @param weekStart Deprecated: Explicit start date (YYYY-MM-DD). Use start_date and week_starts_on instead for locale-aware behavior. This parameter is ignored when week_starts_on is present. To be removed by v2.0.
     * @returns capacity_WeekCalendarResponse OK
     * @throws ApiError
     */
    public static getApiV1CapacityCalendarWeek(
        startDate?: string,
        weekStartsOn?: number,
        days: number = 7,
        weekStart?: string,
    ): CancelablePromise<capacity_WeekCalendarResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/capacity/calendar/week',
            query: {
                'start_date': startDate,
                'week_starts_on': weekStartsOn,
                'days': days,
                'week_start': weekStart,
            },
            errors: {
                400: `Invalid parameters`,
                401: `Authentication required or invalid credentials`,
                403: `Organization ID not found in token`,
                500: `Failed to fetch calendar data`,
            },
        });
    }
    /**
     * Adapt a child's group allocations to their contract versions
     * Previews (dry_run=true) or commits (dry_run=false) the alignment of one child's allocations with their contract versions. The server finds the first day the contract and the allocations differ, cuts the horizon into group periods wherever the existing allocations move the child to another group (a planned baby-to-kids move is kept), proposes one group per weekday and period (kept when the weekday stays in one group of the period, guessed from the period's main group otherwise), and derives the writes: changed allocations end on the day before the change date, new ones are created from it (split into BABY/CHILD by the billing age rules), allocations that already match are kept, hand-made rows after the change date that do not match are removed. A dry run writes nothing; a commit runs the same plan in one transaction. Blockers (stable codes) make the plan non-committable.
     * @param childId Child ID
     * @param request Adapt request
     * @returns capacity_AdaptAllocationsResponse OK
     * @throws ApiError
     */
    public static postApiV1CapacityChildrenAllocationsAdapt(
        childId: string,
        request: capacity_AdaptAllocationsRequest,
    ): CancelablePromise<capacity_AdaptAllocationsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/capacity/children/{child_id}/allocations/adapt',
            path: {
                'child_id': childId,
            },
            body: request,
            errors: {
                400: `Invalid request body or validation failure`,
                401: `Authentication required or invalid credentials`,
                403: `Organization or user ID not found in token`,
                404: `Child not found`,
                409: `Allocation modified by another user`,
                422: `Plan is blocked; the blockers travel in the body`,
                500: `Failed to adapt allocations`,
            },
        });
    }
    /**
     * Get child sync status
     * Get detailed sync status for a specific child
     * @param childId Child ID
     * @returns capacity_ChildCategorizationResponse OK
     * @throws ApiError
     */
    public static getApiV1CapacityChildrenSyncStatus(
        childId: string,
    ): CancelablePromise<capacity_ChildCategorizationResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/capacity/children/{child_id}/sync-status',
            path: {
                'child_id': childId,
            },
            errors: {
                400: `Missing child ID`,
                401: `Authentication required or invalid credentials`,
                403: `Organization ID not found in token`,
                404: `Child not found or has no active contracts`,
                500: `Failed to get child sync status`,
            },
        });
    }
    /**
     * Get children categorization
     * Get categorization of all children with active/upcoming contracts (unallocated, allocated, out-of-sync). Supports search by name or internal ID (including leading zeros).
     * @param limit Limit (default 50, max 100)
     * @param offset Offset (default 0)
     * @param search Search by firstname, lastname, or internal ID (supports partial match and leading zeros)
     * @param includeInactive Include children with no current/upcoming contract (default false)
     * @param ageMinMonths Minimum age in total months, inclusive
     * @param ageMaxMonths Maximum age in total months, inclusive
     * @param ageAsOf Reference date (YYYY-MM-DD) the age bounds are evaluated against; defaults to today
     * @returns capacity_CategorizationListResponse OK
     * @throws ApiError
     */
    public static getApiV1CapacityChildrenCategorization(
        limit?: number,
        offset?: number,
        search?: string,
        includeInactive?: boolean,
        ageMinMonths?: number,
        ageMaxMonths?: number,
        ageAsOf?: string,
    ): CancelablePromise<capacity_CategorizationListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/capacity/children/categorization',
            query: {
                'limit': limit,
                'offset': offset,
                'search': search,
                'include_inactive': includeInactive,
                'age_min_months': ageMinMonths,
                'age_max_months': ageMaxMonths,
                'age_as_of': ageAsOf,
            },
            errors: {
                400: `Invalid query parameter`,
                401: `Authentication required or invalid credentials`,
                403: `Organization ID not found in token`,
                500: `Failed to categorize children`,
            },
        });
    }
    /**
     * Get out-of-sync children
     * Get list of children with sync issues (out-of-sync status only)
     * @param limit Limit (default 50, max 100)
     * @param offset Offset (default 0)
     * @returns capacity_CategorizationListResponse OK
     * @throws ApiError
     */
    public static getApiV1CapacityChildrenOutOfSync(
        limit?: number,
        offset?: number,
    ): CancelablePromise<capacity_CategorizationListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/capacity/children/out-of-sync',
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                401: `Authentication required or invalid credentials`,
                403: `Organization ID not found in token`,
                500: `Failed to get out-of-sync children`,
            },
        });
    }
    /**
     * Get group utilization
     * Calculate capacity utilization for a specific group on a given date
     * @param groupId Group ID
     * @param date Date (YYYY-MM-DD format, defaults to today)
     * @returns capacity_GroupUtilizationResponse OK
     * @throws ApiError
     */
    public static getApiV1CapacityGroupsUtilization(
        groupId: string,
        date?: string,
    ): CancelablePromise<capacity_GroupUtilizationResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/capacity/groups/{group_id}/utilization',
            path: {
                'group_id': groupId,
            },
            query: {
                'date': date,
            },
            errors: {
                400: `Missing group ID or invalid date format`,
                401: `Authentication required or invalid credentials`,
                403: `Organization ID not found in token`,
                404: `Group not found`,
                500: `Failed to calculate group utilization`,
            },
        });
    }
    /**
     * Get group utilization for a date range
     * Calculate capacity utilization for a specific group across a date range
     * @param groupId Group ID
     * @param from From date (YYYY-MM-DD format)
     * @param to To date (YYYY-MM-DD format)
     * @returns capacity_GroupUtilizationRangeResponse OK
     * @throws ApiError
     */
    public static getApiV1CapacityGroupsUtilizationRange(
        groupId: string,
        from: string,
        to: string,
    ): CancelablePromise<capacity_GroupUtilizationRangeResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/capacity/groups/{group_id}/utilization-range',
            path: {
                'group_id': groupId,
            },
            query: {
                'from': from,
                'to': to,
            },
            errors: {
                400: `Missing group ID, missing required params, invalid date format, invalid date range`,
                401: `Authentication required or invalid credentials`,
                403: `Organization ID not found in token`,
                404: `Group not found`,
                500: `Failed to calculate group utilization range`,
            },
        });
    }
    /**
     * Get service breakdown
     * Calculate capacity utilization broken down by service time slots for a specific group on a given date
     * @param groupId Group ID
     * @param date Date (YYYY-MM-DD format)
     * @returns capacity_ServiceBreakdownResponse OK
     * @throws ApiError
     */
    public static getApiV1CapacityGroupsUtilizationServices(
        groupId: string,
        date: string,
    ): CancelablePromise<capacity_ServiceBreakdownResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/capacity/groups/{group_id}/utilization/{date}/services',
            path: {
                'group_id': groupId,
                'date': date,
            },
            errors: {
                400: `Missing group ID or invalid date format`,
                401: `Authentication required or invalid credentials`,
                403: `Organization ID not found in token`,
                404: `Group not found`,
                500: `Failed to calculate service breakdown`,
            },
        });
    }
    /**
     * Get organization capacity overview
     * Calculate capacity utilization for all groups in an organization on a given date
     * @param date Date (YYYY-MM-DD format, defaults to today)
     * @param includeServices If true, populate per-service breakdown for each group
     * @returns capacity_OrgCapacityOverviewResponse OK
     * @throws ApiError
     */
    public static getApiV1CapacityOverview(
        date?: string,
        includeServices?: boolean,
    ): CancelablePromise<capacity_OrgCapacityOverviewResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/capacity/overview',
            query: {
                'date': date,
                'include_services': includeServices,
            },
            errors: {
                400: `Invalid date format`,
                401: `Authentication required or invalid credentials`,
                403: `Organization ID not found in token`,
                500: `Failed to calculate organization capacity overview`,
            },
        });
    }
    /**
     * Get org-wide weeks-granular capacity range
     * Returns, per group, per-week (ISO-8601, Monday-start) capacity aggregates for a span of up to a full calendar quarter (93 days) in a single request — the org-wide, weeks-granular sibling of the per-group utilization-range endpoint. Reuses the batched engine (no per-group N+1).
     * @param from From date (YYYY-MM-DD format)
     * @param to To date (YYYY-MM-DD format)
     * @param granularity Bucketing granularity (only 'week' is supported; defaults to 'week')
     * @param location Childcare ID to scope the results to
     * @param groupId Group ID to scope the results to
     * @returns capacity_OrgCapacityRangeResponse OK
     * @throws ApiError
     */
    public static getApiV1CapacityOverviewRange(
        from: string,
        to: string,
        granularity?: string,
        location?: string,
        groupId?: string,
    ): CancelablePromise<capacity_OrgCapacityRangeResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/capacity/overview/range',
            query: {
                'from': from,
                'to': to,
                'granularity': granularity,
                'location': location,
                'group_id': groupId,
            },
            errors: {
                400: `Missing/invalid params, invalid date range, over 93 days, or unsupported granularity`,
                401: `Authentication required or invalid credentials`,
                403: `Organization ID not found in token`,
                404: `Group not found`,
                500: `Failed to calculate organization capacity range`,
            },
        });
    }
}
